export function uint8ToBase64(input: Uint8Array): string {
    let binary = '';
    const len = input.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(input[i]);
    }
    return btoa(binary);
}

export async function sha256sum(message: string): Promise<string> {
    const hash = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(message));
    const hashArray = Array.from(new Uint8Array(hash));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
